<template>

    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <!--Add Policies and Form section-->
            <div class="admin-page-content add-erg">
                <form id="changeProfile">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Location-->
                            <div class="col-6 forms-block" style="display:none;">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select multiple v-model="locationId"

                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              @input="changedValueRole()"

                                              :filterable="false"
                                              :options="locationArr"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <!--Role-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">HR :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="hrId"
                                                  @change="changedValue"
                                                  @input="changedValueUser()"
                                                  name="hrId"
                                                  id="hrData"
                                                  label="text"
                                                  :filterable="false"
                                                  :options="reportToArr"
                                                  @search="onSearchUserHR"
                                                  placeholder="Select HR">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{hrError}}</font>
                                </div>
                            </div>
                            <!--Title-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <!-- <div class="form-label" for="description">Title :</div> -->
                                    <div class="form-label" for="title">Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="title" type="text" class="form-control" id="title" placeholder="Title" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{titleError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block add-erg-checkbox">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="users">Members  :</div>
                                </div>
                                <div  class="col-12 paddingleft0" >
                              <treeselect v-model="userId"
                                          id="userId"
                                          name="userId"
                                          :options="userArr"
                                          :multiple="true"/>
                                </div>
                            </div>
                            <!--Email :async="true"
                                          :load-options="loadOptions"-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <!-- <div class="form-label" for="description">ERG Form Email :</div> -->
                                    <div class="form-label" for="email">ERG Form Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="email" type="email" class="form-control" id="email" placeholder="Email" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{emailError}}</font>
                                </div>
                            </div>
                            <!--Image-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Upload Image :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{imageError}}</font>
                                    <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                </div>
                            </div>
                            <!--Description-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" :other_options="options"></tinymce>
                                    <font class="text-danger">{{descriptionError}}</font>
                                </div>
                            </div>
                            <!--Attach File-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop2">Attach File :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop2"
                                        :options="dropzoneFileOptions"
                                        ref="dropzoneFile"
                                        :destroyDropzone="false"
                                        :headers="dropzoneFileOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFileAttach"
                                        @vdropzone-success="vfileAttchSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        @vdropzone-total-upload-progress="progressOfUloadAttach"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{attachError}}</font>
                                    <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateSurveys()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addUpdateSurveys(flag='Save and Continue')">
                                    <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateSurveys()"></input>-->
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--page content-->
                </form>
            </div>
            <!--End Add Section-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import tinymce from 'vue-tinymce-editor';
    import Multiselect from 'vue-multiselect';
    import VueSweetalert2 from 'vue-sweetalert2';
    Vue.use(VueSweetalert2);
    import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
    const simulateAsyncOperation = fn => {
            setTimeout(fn, 2000)
        }

    Vue.use(VueCroppie);
    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
            Treeselect,
            Multiselect
        },
        data() {
            return {
                // url: "",
                // urlError: "",
                hr_managerArr: [],
                reportToArr:[],
                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    init: function() {
                          this.on("maxfilesexceeded", function(file) {
                                  Vue.swal('Only single image is allowed');
                                this.removeFile(file);
                                self.isFileUploaded = true;
                          });
                    },
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 50, //MB
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                    // userError:""
                },

                dropzoneFileOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 50, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    init: function() {
                          this.on("maxfilesexceeded", function(file) {
                                Vue.swal('Only single file is allowed');
                                this.removeFile(file);
                                self.isAttachUploaded = true;
                          });
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    // acceptedFiles: "*",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

                imageType: '',
                imageSize: [],
                imagePath: '',
                imageWidth: 0,
                imageHeight: 0,

                attchType: '',
                attchSize: [],
                attchPath: '',
                attchWidth: 0,
                attchHeight: 0,
//                V-model
                locationId: '',
                userId:[],
                userModelId:[],
                locationArr: [],
                userArr:[],
                email:'',
                hrId: 0,
                // roleArr: [],
                title: '',
                redirectionLink: '',
                contactEmail: '',
                contactNumber: '',
                description: '',
                pageTitle: 'Add ERG',

//                FrontEnd Errors
                titleError: '',
                emailError:'',
                redirectionLinkError: '',
                contactEmailError: '',
                contactNumberError: '',
                descriptionError: '',
                hrError: '',
                locationError: '',

                imageError: '',
                attachError: '',
                isFileUploaded: false,
                isAttachUploaded: false,

//                BackEnd Error
                backendErrors: [],
                fileUploaded: true,
                attachmentUploaded: true,
            }
        },
        mounted: function () {
            self = this;
            self.checkLogin();
            self.loadLocationsAdd();
            self.loadUsersOnly();
            self.loadUsersManager();
           // self.loadRole();
            self.loadLocations();
            //self.getHrAndManagers();

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updateerg') {
                if (segments[3]) {
                    self.loadPoliciesAndForms();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit ERG";
                }
            }

            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#email").on('keyup', function () {
                self.emailError = '';
            });
            $("#userId").on('keyup', function () {
                // self.userError = '';
            });
            $("#hrId").on('keyup', function () {
                self.hrError = '';
            });
            $("#redirectionLink").on('keyup', function () {
                self.redirectionLinkError = '';
            });
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });


            $("#drop1").on('change', function () {
            });

            $("#drop2").on('change', function () {
            });

            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/

        },
        watch: {

        },
        methods: {
            loadOptions({ action, searchQuery, callback }) {
                
                if (action === ASYNC_SEARCH) {
                    simulateAsyncOperation(() => {
                        searchQuery = (searchQuery === null || typeof (searchQuery) === "undefined" || searchQuery == '') ? '' : searchQuery;
                        
                        var data = {
                            search: searchQuery
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                            params: {
                                search: searchQuery,
                                erg:2,
                                except_self : 1,
                            }
                        };
                        HTTP.post("getusers", data,config)
                                .then(function (response) {
                                    self.userArr = [];
                                    var i;
                                    for(i=0;i<=response.data.content.length;i++)
                                    {
                                    self.userArr.push( {
                                        label: response.data.content[i].text,
                                        id: response.data.content[i].value,
                                    });
                                    }

                                    if (typeof (loading) != "undefined") {
                                        loading(false);
                                    }
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                });

                                // console.log('userArruserArruserArr');
                                // console.log(self.userArr);
                        // const options = [ 1, 2, 3, 4, 5 ].map(i => ({
                        //     id: `${search}-${i}`,
                        //     label: `${search}-${i}`,
                        // }))
                        callback(null, self.userArr)
                    })
                }
            },
            loadUsersOnly(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                 var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                        erg:2,
                        except_self : 1,
                    }
                };
                HTTP.post("getusers", data,config)
                        .then(function (response) {
                            var i;
                            for(i=0;i<=response.data.content.length;i++)
                            {
                                if(response.data.content[i]){
                                    self.userArr.push( {
                                    label: response.data.content[i].text,
                                    id: response.data.content[i].value,
                                });
                                }
                            }

                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            //from backend no status is there.
                            // if (err.response.status == 0) {
                            //     self.error = "Remote server can not be reachable";
                            // } else {
                            //     //redirect to login page if user not authenticated
                            //     if (err.response.status == 401) {
                            //         //clear previous data
                            //         localStorage.removeItem("user_obj");
                            //         localStorage.removeItem("api_token");
                            //         self.$router.push("/login");
                            //         //EventBus.$emit("logged-in", true, "", "");
                            //     }
                            //     self.error = err.response.data.message;
                            // }
                            console.log(err);
                        });
            },
            customLabel (option) {
              return `${option.text}`
            },
            onSelect (option) {
            //   console.log("Added");
              let index = this.options.findIndex(item => item.library==option.library);
              this.options[index].checked = true;
            //   console.log(option.library + "  Clicked!! " + option.checked);
            },
            validEmail: function (email) {
              var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return re.test(email);
            },
              onRemove (option) {
            //   console.log("Removed");
              let index = this.options.findIndex(item => item.library==option.library);
              this.options[index].checked = false;
            //   console.log(option.library + "  Removed!! " + option.checked);
            },
            new_thumbnail_added:function (file) {
            //   console.log("new file ==", file);
            },
            changedValueUser: function () {
                self.hrError = "";
            },
            onSearchUserHR(search, loading) {
                let self = this;
                /*if (self.siteid != null && self.siteid != "") {*/
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    self.loadUsersManager(loading, search, this);
                }
                /*}*/
            },
            loadUsersManager(loading, search, vm) {
                let self = this;
                var siteId = "";
                var departmentId = "";
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                        except_self : 1,
                    }
                };
                /* var fields = {
                    search: search,
                    except_self : 1,
                }; */
                HTTP.get("gethrandmanager", config)
                        .then(function (response) {
                            self.reportToArr = [];
                            $.each(response.data.content, function (i) {
                                self.reportToArr.push(response.data.content[i]);
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                // redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            // getHrAndManagers: function() {
            //   var config = {
            //             headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            //             params: {
            //               except_self : self.userId
            //             }
            //         };
            //         HTTP.get('gethrandmanager', config)
            //             .then(function (response) {
            //               self.hr_managerArr = response.data.content;
            //             }).catch(function (err) {
            //                 // $('#exportUsers').text('Export');
            //                 // $('#exportUsers').prop("disabled", false);
            //                 if (err.response.status == 0) {
            //                     if (err.response.status == 0) {


            //                     } else {
            //                         //redirect to login page if user not authenticated
            //                         if (err.response.status == 401) {
            //                             //clear previous data
            //                             localStorage.removeItem("user_obj");
            //                             localStorage.removeItem("api_token");
            //                             localStorage.removeItem("profile_image");
            //                             self.$router.push("/login");
            //                             //EventBus.$emit("logged-in", true, "", "");
            //                         }
            //                         self.error = err.response.data.message;
            //                     }
            //                 }
            //                 self.exportUsers = false;
            //             });

            // },
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listerg');
            },

            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },

            removeAllFiles1() {
                // self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },
            removeAllAttchFiles() {
                self.$refs.dropzoneFile.removeAllFiles();
                self.isAttachUploaded = false;
            },

            vfileSuccess: function (file, response) {
                self.imagePath=response.content.media_path;
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imageType=file.type;
                self.imageSize=file.size;
                self.imageWidth = file.width;
                self.imageHeight = file.height;
                self.imageError = '';
            },

            vfileAttchSuccess: function (file, response) {
            //   console.log(response);
                self.attchPath=response.content.media_path;
                self.isAttachUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.attchType=file.type;
                self.attchSize=file.size;
                self.attchWidth = file.width;
                self.attchHeight = file.height;
                self.attachError = '';
            },


            removedSelectedFile(file, xhr, error) {
                // if (self.imagePath.length <= 0) {
                    self.isFileUploaded = false;
                    self.imagePath = '';

                // }
                var filePath = JSON.parse(file.xhr.response);
                //console.log(file);
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
                // for (var i = self.imagePath.length - 1; i >= 0; i--) {
                //     if (self.imagePath[i] === filePath.content.media_path) {
                //         self.imagePath.splice(i, 1);
                //         self.imageType.splice(i, 1);
                //         self.imageSize.splice(i, 1);
                //         self.imageHeight = 0;
                //         self.imageWidth = 0;
                //     }
                // }
            },

            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            // console.log("File removed successfully");
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },

            changedValue: function (value) {
                // console.log(value);
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            console.log(self.locationArr);
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadLocations() {
                HTTP.post("/getlocation")
                        .then(function (response) {
                            self.locationArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            onSearchUser(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadUsersOnly(loading, search, this);
                }
            },

            // loadRole() {
            //     var config = {
            //         headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
            //     };
            //     HTTP.post("getroles", '', config)
            //             .then(function (response) {
            //                 self.roleArr = [];
            //                 $.each(response.data.content, function (i) {
            //                     self.roleArr.push(response.data.content[i]);
            //                 });
            //             })
            //             .catch(function (err) {
            //                 if (err.response.status == 0) {
            //                     self.error = "Remote server can not be reachable";
            //                 } else {
            //                     //redirect to login page if user not authenticated
            //                     if (err.response.status == 401) {
            //                         //clear previous data
            //                         localStorage.removeItem("user_obj");
            //                         localStorage.removeItem("api_token");
            //                         self.$router.push("/login");
            //                         //EventBus.$emit("logged-in", true, "", "");
            //                     }
            //                 }
            //             });
            // },
            changedValueRole() {
                self.hrError = '';
            },

            checkForm: function () {
                var checked = true;
                // if (self.locationId.length === 0) {
                //     self.locationError = "State Required";
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                // if (self.userId.length === 0) {
                //     self.locationError = "Users Required";
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                if (!self.hrId) {
                    self.hrError = "HR Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.email)) {
                    self.emailError="Valid email required";
                    if (checked) {
                          checked = false;
                      }
                }
                if (self.isFileUploaded == false) {
                    self.imageError = "Please Upload Image";
                    if (checked) {
                        checked = false;
                    }
                }
                self.attachError = "";
                if (self.isAttachUploaded == false) {
                    self.attachError = "Please Upload Attachment";
                    if (checked) {
                        checked = false;
                    }
                }

                if (self.fileUploaded == false) {
                    self.imageError = "Please Wait While Image Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.attachmentUploaded == false) {
                    self.attachError = "Please Wait While Attachment Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadPoliciesAndForms() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("geterg/" + segments[3], data, config)
                        .then(function (response) {
                        //   console.log("GET READ");
                            // self.locationId = {
                            //     value: response.data.content[0].location_id,
                            //     text: response.data.content[0].location_name,
                            // };

                            self.locationId = [];
                            for (var i = 0; i < response.data.content.location.length; i++) {
                                self.locationId.push({'text': 'All', 'value': 0});
                            }
                            // console.log('Location :'+locationId);
                            // console.log("Users:"+response.data.content.users_id[0].text);
                            // self.userId=[];

                            // console.log('sad'+response.data.content);

                            for (var i = 0; i < response.data.content.users_id.length; i++) {
                                // self.userId.push({'text': response.data.content.users_id[i].first_name + ' ' + response.data.content.users_id[i].last_name + ' ' + response.data.content.users_id[i].username , 'value': response.data.content.users_id[i].id , 'name':});
                                // self.userId.push({text: response.data.content.users_id[i].text ,
                                //       value: response.data.content.users_id[i].value,
                                //       name: response.data.content.users_id[i].text,
                                //       id: response.data.content.users_id[i].value,
                                //       checked:true
                                // });
                                self.userId.push(response.data.content.users_id[i].id);
                                // alert(response.data.content.users_id[i].value);
                                // alert(response.data.content.users_id[i].text);
                                // self.userId.push( {
                                //         lable: response.data.content.users_id[i].text,
                                //         id: response.data.content.users_id[i].id,
                                //     });


                            }
                            // console.log('Loca:'+locationId);
                            // console.log('users :'+userId);
                            self.hrId = {
                                id: response.data.content.hr_id,
                                name: response.data.content.hr_name,
                                text:response.data.content.hr_name,
                                value:response.data.content.hr_id,
                                role:"HR"
                            };
                            self.email = response.data.content.email;
                            self.title = response.data.content.title;
                            self.imagePath=response.data.content.image_path;
                            self.attchPath=response.data.content.attachment_path;
                            self.redirectionLink = response.data.content.redirection_link;
                            self.contactEmail = response.data.content.contact_email;
                            self.contactNumber = response.data.content.contact_number;
                            self.description = response.data.content.description;

                            if (self.imagePath != '') {
                                self.isFileUploaded = true;
                                self.imageSize=response.data.content.image_size;
                                self.imageWidth = 1200;
                                self.imageHeight = 450;
                                //self.imagePath = '';
                            }


                            if (self.attchPath != '') {
                                self.isAttachUploaded = true;
                                self.attchSize=response.data.content.attachment_size;
                                self.attchWidth = 1200;
                                self.attchHeight = 450;
                                //self.imagePath = '';
                            }
                            self.uploadManually();
                            self.hideLoader();
                        })
                        // .catch(function (err) {
                        //     if (err.response.status == 0) {
                        //         self.error = "Remote server can not be reachable";
                        //     } else {
                        //         //redirect to login page if user not authenticated
                        //         if (err.response.status == 401) {
                        //             //clear previous data
                        //             localStorage.removeItem("user_obj");
                        //             localStorage.removeItem("api_token");
                        //             localStorage.removeItem("profile_image");
                        //             self.$router.push("/login");
                        //             //EventBus.$emit("logged-in", true, "", "");
                        //         }
                        //         self.error = err.response.data.message;
                        //     }
                        //     self.hideLoader();
                        // });
            },

            removedSelectedFileAttach(file, xhr, error) {
                // if (self.attchPath.length <= 0) {
                    self.isAttachUploaded = false;
                // }
                // console.log("Media Path::"+response.content);
                var filePath = JSON.parse(file.xhr.response);
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
                // for (var i = self.attchPath.length - 1; i >= 0; i--) {
                //     if (self.attchPath[i] === filePath.content.media_path) {
                //         self.attchPath.splice(i, 1);
                //         self.attchType.splice(i, 1);
                //         self.attchSize.splice(i, 1);
                //         self.attchHeight = 0;
                //         self.attchWidth = 0;
                //     }
                // }
            },

            uploadManually(file) {
              // console.log(self.imagePath.length);
                if (self.imagePath!= '') {
                    var file_name = self.getFileName(self.imagePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.imagePath;
                    let file_size = self.imageSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }
                // console.log(self.attchPath.length);
                if (self.attchPath!='') {
                    var file_name = self.getFileName(self.attchPath);
                    let file_type = self.getFileType(file_name);
                    let url = self.attchPath;

                    let file_size = self.attchSize;
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzoneFile.manuallyAddFile(file_data, url);

                    //as now file type is passed as application/type..static url is not needed and also commented thumbnail
                    // if(url.includes("pdf")) {
                    // //   console.log(url);
                    //   // url = url.split('/').slice(0,-1).join('/')+'/pdf-thumb.png'
                    //   url = '/static/images/thumbs/pdf-thumb.png'

                    // }


                    // let file_size = self.attchSize;
                    // let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type, dataURL: url};
                    // self.$refs.dropzoneFile.manuallyAddFile(file_data, url);
                    // this.$refs.dropzone.dropzone.emit('thumbnail', file_data, file_data.dataURL)

                    // Dropzone.options.myAwesomeDropzone = {
                    //   init: function() {
                    //     this.on("success", function(file) {
                    //       this.createThumbnailFromUrl(file, newimage);
                    //     });
                    //   }
                    // };


                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                if(file_type.includes('jpg') || file_type.includes('jpeg')){
                    return 'image/' + file_type;
                }
                return 'application/' + file_type;
            },

            addUpdateSurveys(flag) {
                /*console.log("Befor form check");*/
                self.checkForm();
                if (self.checkForm()) {
                    /*console.log("form check success");*/
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    // console.log("lo == ", self.locationId);
                    // console.log("lo == ", self.userId);

                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId = 'All';
                    }
                    var usersId='';
                    for (var i = 0; i < self.userId.length; i++) {
                        usersId += (self.userId[i]) + ',';
                    }

                    usersId = usersId.replace(/,\s*$/, "");

                    // locationsId = locationsId.replace(/,\s*$/, "");
                    // console.log("location22 =", locationsId);
                    // console.log("Users =", usersId);



                    if (segments[2] == 'updateerg') {
                        if (segments[3]) {
                            var data = {
                                hrId: self.hrId.id,
                                locationId: '0',
                                userIdList:usersId,
                                title: self.title,
                                redirectionLink: self.redirectionLink,
                                contactEmail: self.contactEmail,
                                contactNumber: self.contactNumber,
                                description: self.description,
                                mediaPath: self.imagePath,
                                mediaType: self.imageType,
                                mediaSize: self.imageSize,
                                attachPath: self.attchPath,
                                attachType: self.attchType,
                                attachSize: self.attchSize,
                                email:self.email,
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            hrId: self.hrId.id,
                            locationId: 0,
                            userIdList:usersId,
                            title: self.title,
                            redirectionLink: self.redirectionLink,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                            description: self.description,
                            email:self.email,
                            mediaPath: self.imagePath,
                            mediaType: self.imageType,
                            mediaSize: self.imageSize,
                            attachPath: self.attchPath,
                            attachType: self.attchType,
                            attachSize: self.attchSize,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdateerg", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                self.removeAllAttchFiles();
                                if (segments[2] == 'updateerg') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
                                        //  $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.userId=[];
                                        self.locationArr = [];
                                        self.userArr = [];

                                        self.hrId = '';
                                        self.email='';
                                        self.hr_managerArr = [];
                                        self.title = '';
                                        self.redirectionLink = '';
                                        self.contactEmail = '';
                                        self.contactNumber = '';
                                        self.description = '';
                                        self.loadLocationsAdd();
                                        self.loadUsersOnly();
                                        self.loadUsersManager();

                                        // self.loadRole();
                                        //self.getHrAndManagers();
                                        self.loadLocations();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 3000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                self.removeAllAttchFiles();
                                if (segments[2] == 'updateerg') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            $(".alert-success").removeClass("hide");
                                            $(".alert-success").addClass("show");
                                            self.removeAllFiles();
                                            self.removeAllAttchFiles();
                                            self.locationId = '';
                                            self.userId=[];
                                            self.locationArr = [];
                                            self.userArr = [];
                                            self.hrId = '';
                                            self.email='';
                                            self.hr_managerArr = [];
                                            self.title = '';
                                            self.redirectionLink = '';
                                            self.contactEmail = '';
                                            self.contactNumber = '';
                                            self.description = '';
                                            self.loadLocationsAdd();
                                            self.loadUsersOnly();
                                            self.loadUsersManager();

                                            // self.loadRole();
                                            //self.getHrAndManagers();
                                            self.loadLocations();
                                            $("#status option[value='']").attr('selected', true);
                                            $("#type option[value='']").attr('selected', true);

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        $(".alert-success").removeClass("hide");
                                        $(".alert-success").addClass("show");
                                        self.removeAllFiles();
                                        self.removeAllAttchFiles();
                                        self.locationId = '';
                                        self.userId=[];
                                        self.email='';
                                        self.locationArr = [];
                                        self.userArr = [];
                                        self.hrId = '';
                                        self.hr_managerArr = [];
                                        self.title = '';
                                        self.redirectionLink = '';
                                        self.contactEmail = '';
                                        self.contactNumber = '';
                                        self.description = '';
                                        self.loadLocationsAdd();
                                        self.loadUsersOnly();
                                        self.loadUsersManager();
                                        // self.loadRole();
                                        self.getHrAndManagers();
                                        self.loadLocations();

                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.imageError = "";
                } else {
                    self.fileUploaded = false;
                }
            },
            progressOfUloadAttach(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.attachmentUploaded = true;
                    self.attachError = "";
                } else {
                    self.attachmentUploaded = false;
                }
            },
        }
    }
// <script src="https://unpkg.com/vue-multiselect@2.1.6/dist/vue-multiselect.min.js"></script>

</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/backend/ERGs/AddERG.vue